export default "__VITE_ASSET__D5JNfu0u__"